<script>
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import RightBar from '@components/right-bar'
import localDatatable from "@/src/components/local-datatable.vue";
import ActionButton from '@components/buttons/ActionButton.vue'
import LabelCanvas from '@components/LabelCanvas.vue'
import LabelCanvasThumbnail from '@components/LabelCanvasThumbnail.vue'
import CompaniesModal from './CompaniesModal.vue'
import StoresModal from './StoresModal.vue'
import AccessPointsModal from './AccessPointsModal.vue'
import LabelsModal from './LabelsModal.vue'
import ItemsModal from './ItemsModal.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import { accessPointMethods, manageStoreMethods } from "@state/helpers";

export default {
    page: {
        title: "Administration/Stores",
        meta: [{ name: "Stores management", content: "Administration/Stores" }],
    },
    components: { 
        ActionButton,
        Layout,
        RightBar,
        PageHeader,
        LabelCanvas,
        LabelCanvasThumbnail,
        CompaniesModal,
        StoresModal,
        AccessPointsModal,
        LabelsModal,
        ItemsModal,
        ValidationProvider, 
        ValidationObserver,
        localDatatable
    },
    data() {
        return {
            title: "Store Administration",
            breadCrumb: [
                {
                    text: "Store Administration",
                    href: "/",
                },
            ],
            createUpdateModalShow: false,
            createUpdateModal: {
                title: '',
                id: '',
            },
            message: 'Esperando datos del servidor...',
            companies: [],
            stores: [],
            access_points: [],
            references: [],
            devices: [],
            devicesFields: [
                { key: "id", label: 'labels.deviceVariables.id' },
                { key: "reference_id", label: 'labels.deviceVariables.reference_id' },
                { key: "location_id", label: 'labels.deviceVariables.location_id' },
                { key: "last_battery", label: 'labels.deviceVariables.last_battery' },
                { key: "last_rf_power", label: 'labels.deviceVariables.last_rf_power' },
                // { key: "last_temperature", label: 'labels.deviceVariables.last_temperature' },
                { key: "last_time", label: 'labels.deviceVariables.last_time' },
                { key: "template", label: 'labels.deviceVariables.template' },
                { key: "item_id", label: 'labels.deviceVariables.item_id' },
                { key: "actions", label: 'basic.actions' },
            ],
            items: [],
            itemsFields: [
                { key: "ean", label: 'labels.templateVariables.$ean' },
                { key: "description1", label: 'labels.templateVariables.$description1' },
                { key: "description2", label: 'labels.templateVariables.$description2' },
                { key: "price1", label: 'labels.templateVariables.$price1' },
                { key: "price2", label: 'labels.templateVariables.$price2' },
                { key: "sku", label: 'labels.templateVariables.$sku' },
                { key: "und", label: 'labels.templateVariables.$und' },
                { key: "labels", label: 'labels.templateVariables.$labels' },
                { key: "actions", label: 'basic.actions' }
            ],
            templates: [],
            activeCompany: {},
            companyEdit: {},
            activeAccessPoint: {},
            activeStore: {},
            lastTime: null,
            LEDTimes: 5,
            LEDColor: null,
            selectedTags: [],
            selectedTag: {},
            selectedItem: {},
            action: '',
            isLoading: false,
            reloadKey: 0,
        }
    },
    methods: {
        ...accessPointMethods,
        ...manageStoreMethods,
        async _getCompanies(){
            this.isLoading = true;
            await this.fetchCompaniesList().then((response) => {
                this.companies = _.cloneDeep(response.data.results);
                this.isLoading = false;
            })
        },
        _getStores(company=null){
            this.isLoading = true;
            if(company){
                this.activeCompany = company
            }
            this.fetchStores({company_id: this.activeCompany._id}).then((response) => {
                this.stores = _.cloneDeep(response.data.results)
                this.isLoading = false;
            })  
        },
        _getAccessPoints(store=null){
            this.isLoading = true;
            if (store){
                this.activeStore = store;
                this.items = [];
                this.devices = [];
            }
            this.fetchAccessPointsByStore({store_id: this.activeStore._id}).then((response) => {
                this.access_points = _.cloneDeep(response.data.results)
                this._getItems(); 
                this._getLabels();
                this.isLoading = false;
            }) 
        },
        _getItems(){
            this.isLoading = true;
            this.fetchItems({store_id: this.activeStore._id}).then((response) => {
                this.items = _.cloneDeep(response.data.results);
                this.isLoading = false;
            })
        },
        _fetchTemplates(){
            this.fetchTemplates().then((response) => {
                this.templates = _.cloneDeep(response.data.results);
            })
        },
        async _getLabels(){
            this.isLoading = true;
            this.devices = [];
            this.lastTime = new Date();
            await this.fetchLabels({
                store_id: this.activeStore._id,
            }).then(async response => {
                this.devices = response.data.results
                this.isLoading = false;
                // this.$nextTick(async ()=>{
                //     this.$refs.tableLabels.refresh();
                // })
            }).catch(error => {
                console.error('Error en la solicitud POST:', error);
            });
        },
        getLabelsByAP(access_point){
            if (access_point){
                this.activeAccessPoint = access_point;
            } else {
                this.activeAccessPoint = {}
            }
        },
        _taskTemplate(){
            this.isLoading = true;
            this.access_points.forEach(ap => {
                let tagIDs = this.selectedTags.filter(x => x.ap === ap.id).map(y => y.id)
                if (tagIDs.length === 0) return;
                this.taskTemplate({
                    eStationCode: ap.id,
                    fabricant: ap.fabricant,
                    storeCode: "7788",
                    language: "ES",
                    tagIDs: tagIDs,
                })
                .then(response => {
                    this.isLoading = false;
                    console.info(response.data);
                })
                .catch(error => {
                    console.error('Error en la solicitud POST:', error);
                }); 
            });
            
        },
        setColor(color){
            this.LEDColor = color;    
        },
        _flashingLED(){
            this.isLoading = true;
            this.access_points.forEach(ap => {
                this.flashingLED({
                    eStationCode: ap.id,
                    storeCode: "7788",
                    language: "ES",
                    times: this.LEDTimes,
                    color: this.LEDColor,
                    tagIDs: this.selectedTags.filter(x => x.ap === ap.id).map(y => y.id)
                })
                .then(response => {
                    console.log(response)
                    this.isLoading = false;
                    this.LEDColor = null;    
                })
                .catch(error => {
                    console.error('Error en la solicitud POST:', error);
                });
            });
        },
        _getInformationDetail(tag){
            this.isLoading = true;
            this.getInformationDetail({
                eStationCode: tag.access_point_id,
                storeCode: "7788",
                language: "ES",
                tagIDs: [tag.id]
            })
            .then(response => {
                this.isLoading = false;
                // Actualiza la información en el div con la respuesta del servidor
                console.info(response.data);
            })
            .catch(error => {
                console.error('Error en la solicitud POST:', error);
            });
        },
        
        getColorRGB(color){
            switch (color ? color : this.LEDColor) {
                case null: return { 'color': 'transparent !important' }; break;
                case 'R': return { 'color': 'rgb(255,0,0) !important' }; break;
                case 'G': return { 'color': 'rgb(0,255,0) !important' }; break;
                case 'B': return { 'color': 'rgb(0,0,255) !important' }; break;
                case 'R,G': return { 'color': 'rgb(255,255,0) !important' }; break;
                case 'R,B': return { 'color': 'rgb(255,0,255) !important' }; break;
                case 'G,B': return { 'color': 'rgb(0,255,255) !important' }; break;
                case 'R,G,B': return { 'color': 'rgb(255,255,255) !important' }; break;
            }
        },
        
        sseHandleMessage(data){
            let context = this;
            if (Object.keys(data).length > 0){
                if (data.topic === 'heartbeat'){
                    // let index = context.access_points.findIndex(x => x.id === data.id)
                    // if (index !== -1) {
                        //     context.$set(context.access_points, index, data);
                        // } else {
                            //     // por aquí no debería entrar, porque lo que reciba es lo que se envía en la consulta.
                            //     context.$set(context.access_points, context.access_points.length, data);
                            // }
                } else if(data.topic === 'result'){ // SUNY
                    for (let tag = 0; tag < data.tags.length; tag++) {
                        let element = data.tags[tag];
                        element.time = data.time;
                        let founded = context.devices.find(x => x.id === element.tag_id)
                        founded.last_battery = element.battery
                        founded.last_rf_power = element.rf_power
                        founded.last_temperature = element.temperature
                        founded.last_time = new Date(element.time).getTime().toString()
                    }
                } else if(data.topic === 'property'){
                    for (let tag = 0; tag < data.tags.length; tag++) {
                        let element = data.tags[tag];
                        element.time = data.time;
                        let founded = context.devices.find(x => x.id === element.code.toString().toUpperCase())
                        if (!founded) continue;
                        if (element.power){
                            founded.last_battery = element.power * 0.3 // for frontend displaying
                        }
                        if (element.last_rf_power){
                            founded.last_rf_power = element.average_rssi
                        }
                        founded.last_temperature = null
                        founded.last_time = new Date(element.time).getTime().toString()
                    }
                }
                context.lastTime = data.time
            }
        },
        sseHandleError(error){
            console.error('Error en la conexión SSE:', error.toString());
        },
        getTimeFormatted(date1) {
            if (!date1) return 'Ø'
            var date2 = new Date().getTime();

            var millDifference = date2 - date1;

            var seconds = Math.floor(millDifference / 1000);
            var minutes = Math.floor(seconds / 60);
            var hours = Math.floor(minutes / 60);
            var days = Math.floor(hours / 24);
            seconds %= 60;
            minutes %= 60;
            hours %= 24;

            return `${days > 0 ? days+'d' : ''} ${hours > 0 ? hours +'h' : ''} ${minutes > 0 ? minutes+'m' : ''} ${seconds > 0 ? seconds+'s' : ''}`
        },
        
        
        async selectTemplate(device){
            this.selectedTag = await _.cloneDeep(device); 
            this.action = 'labelCanvas'
            this.$nextTick(async () => {
                this.toggleRightSidebar(); 
            });
        },
        
        toggleRightSidebar() {
            document.body.classList.toggle('right-bar-enabled')
        },
        openCreateUpdateModal(company, action) {
            // this.resetCreateUpdateModal(action)
            if (action === 'create'){
                this.action = 'create'
                this.createUpdateModal.title = this.$t('basic.create')+' '+this.$t('fields.store')
            } else if (action === 'update'){
                this.action = 'update'
                this.createUpdateModal.title = this.$t('basic.update')+' '+this.$t('fields.store')
                // this.updateForm.url = item.url
                // this.updateForm.name = item.permission.name
                // this.updateForm.codename = item.permission.codename
                // this.updateForm.description = item.description
            }
            this.createUpdateModalShow = !this.createUpdateModalShow
        },
        async closeItemsModal(action){
            if(action === 'true'){ 
                await this._getLabels(this.activeAccessPoint); 
                await this._getItems()
            }
            this.action = '';
        },
        async closeCompaniesModal(action){
            if(action === 'true'){ 
                await this._getLabels(this.activeAccessPoint); 
                await this._getItems()
            }
            this.action = '';
        },
        async closeStoresModal(action){
            if(action === 'true'){ 
                await this._getStores(); 
            }
            this.action = '';
        },
        async closeAccessPointsModal(action){
            if(action === 'true'){ 
                await this._getAccessPoints(); 
            }
            this.action = '';
        },
        async closeLabelsModal(action){
            if(action === 'true'){ 
                await this._getAccessPoints(); 
                await this._getLabels(); 
            }
            this.action = '';
        },
        async closeLabelCanvas(action){
            await this._getLabels(this.activeAccessPoint); 
        },
        companyCreated(resp){
            this.action = ''; 
            //TODO: Validar respuesta (200, o company.id?)
            this.$generate_noty('success', "Se ha creado la compañía correctamente!", "", 3000, true);
            this._getCompanies()
        },
        storeCreated(resp){
            this.action = ''; 
            //TODO: Validar respuesta (200, o store.id?)
            this.$generate_noty('success', "Se ha creado la tienda/sucursal correctamente!", "", 3000, true);
            this._getCompanies()
            this._getStores()
        },
        accessPointCreated(resp){
            this.action = ''; 
            //TODO: Validar respuesta (200, o access_point.id?)
            this.$generate_noty('success', "Se ha creado el access point correctamente!", "", 3000, true);
            this._getStores()
            this._getAccessPoints()
        },
        labelCreated(resp){
            this.action = ''; 
            //TODO: Validar respuesta (200, o label.id?)
            this.$generate_noty('success', "Se ha creado la etiqueta correctamente!", "", 3000, true);
            this._getAccessPoints()
            this._getLabels()
        },
        getTranslation(key){
            return this.$t(key)
        }
    },
    computed: {
        getColorName(){
            switch (this.LEDColor) {
                case null: return "LED Color"; break;
                case 'R': return "Red"; break;
                case 'G': return "Green"; break;
                case 'B': return "Blue"; break;
                case 'R,G': return "Yellow"; break;
                case 'R,B': return "Magenta"; break;
                case 'G,B': return "Cyan"; break;
                case 'R,G,B': return "White"; break;
            }
        },
        isEditAvailable(){
            return this.$store.state.auth.currentSession.user.is_superuser
        },
        filteredDevices(){
            if (Object.keys(this.activeAccessPoint).length > 0){
                return this.devices.filter(x => x.access_point_id === this.activeAccessPoint.id)
            } else {
                return this.devices
            }
        },
        availableTags(){
            return this.devices.filter(x => x.item_id === null || !x.hasOwnProperty('item_id'))
        }
    },
    watch: {
        // '$i18n.locale': function(newVal, oldVal) {
        //     this.lastTime = new Date()
        // }
    },
    mounted() {
        this._getCompanies();
        this._fetchTemplates();
        this.fetchReferences().then((response) => {
            this.references = _.cloneDeep(response.data.results);
        })
        setInterval(() => {
            this.reloadKey = Math.floor(Math.random() * 1000)
        }, 1000)

        //TODO - Get language dynamically (from user language or selection?)
        
        let context = this
        context.subscribeSSE({ companyId: 1, 
            handleMessage: context.sseHandleMessage.bind(context), 
            handleError: context.sseHandleError.bind(context)
        });
    },
};
</script>
    
    <template>
        <Layout>
            <PageHeader :title="title" :items="breadCrumb" />
            <RightBar v-if="Object.keys(activeCompany).length > 0 && Object.keys(selectedTag).length > 0 && Object.keys(items).length > 0 && action === 'labelCanvas'" title="Selección de plantilla" >
                <LabelCanvas :activeCompanyId="activeCompany._id" :selectedTag="selectedTag" :items="items" :onClose="closeLabelCanvas" :onLabelUpdated="() => { _fetchTemplates() }" ></LabelCanvas>
            </RightBar>
            <CompaniesModal v-if="action === 'companiesModal'" 
                :activeCompany="activeCompany" 
                :companyEdit="companyEdit"
                :callback="companyCreated"
                :closeModal="closeCompaniesModal" >
            </CompaniesModal>
            <StoresModal v-if="action === 'storesModal'" 
                :activeCompany="activeCompany" 
                :callback="storeCreated"
                :closeModal="closeStoresModal" >
            </StoresModal>
            <AccessPointsModal v-if="action === 'accessPointsModal'" 
                :activeStore="activeStore" 
                :callback="accessPointCreated"
                :closeModal="closeAccessPointsModal" >
            </AccessPointsModal>
            <LabelsModal v-if="action === 'labelsModal'" 
                :activeStore="activeStore" 
                :activeAccessPoint="activeAccessPoint" 
                :references="references"
                :templates="templates"
                :callback="labelCreated"
                :closeModal="closeLabelsModal" >
            </LabelsModal>
            <ItemsModal v-if="activeStore && Object.keys(selectedTag).length > 0 && action === 'itemsModal'" 
                :activeStore="activeStore" 
                :selectedTag="selectedTag" 
                :action="action"
                :closeModal="closeItemsModal" >
            </ItemsModal>
            <ItemsModal v-if="activeStore && (action === 'itemsModalCreate' || action === 'itemsMassiveModalCreate' || action === 'itemsModalEdit')" 
                :activeStore="activeStore"  
                :activeAccessPoint="activeAccessPoint"
                :activeItem="selectedItem"
                :availableTags="availableTags"
                :action="action"
                :closeModal="closeItemsModal" >
            </ItemsModal>

            <!-- posible componente aquí - breadcumb -->
            <div class="mb-1">
                <b-button  variant="link" @click="() => {  stores = []; access_points = []; devices = []; activeCompany = {}; activeStore = {};  activeAccessPoint = {} }">
                    <i class="fad fa-home"></i> {{ $t('pages.Home') }}</b-button>
                
                <i class="fad fa-chevron-right mr-1"></i>

                <span v-if="Object.keys(companies).length >= 0 && Object.keys(activeCompany).length === 0">
                    <i class="fad fa-buildings"></i> {{ $tc('fields.company', 2) }}
                </span>
                <span v-else-if="Object.keys(companies).length > 0 || Object.keys(activeCompany).length > 0">
                    <b-button  variant="link" @click="() => { _getStores(); access_points = []; devices = []; activeStore = {};  activeAccessPoint = {} }">
                        <i class="fad fa-buildings"></i> {{ activeCompany.brand }}
                    </b-button>
                    <i class="fad fa-chevron-right"></i>
                </span>

                <span v-if="Object.keys(stores).length > 0 && Object.keys(activeStore).length === 0">
                    <i class="fad fa-store ml-1"></i> {{ $tc('fields.store', 2) }}
                </span>
                <span v-else-if="Object.keys(stores).length > 0">
                    <b-button variant="link" @click="async () => { activeAccessPoint = {}; _getAccessPoints(); }">
                        <i class="fad fa-store ml-1"></i> {{ activeStore.name }}</b-button> 
                    <i class="fad fa-chevron-right"></i>
                </span>

                <span v-if="Object.keys(activeStore).length > 0">
                    <i class="fad fa-mobile ml-1"></i> {{ $t('fields.devices') }}
                </span>
            </div>
            <b-overlay :show="isLoading" 
                    spinner-variant="primary"
                    spinner-type="grow"
                    spinner-small
                    rounded="sm">
                <b-card no-body class="p-2 pb-0" :data-time="lastTime">
                    <div>
                        <!-- Companies -->
                        <div v-if="Object.keys(activeCompany).length === 0">
                            <b-button v-for="company in companies" 
                                variant="light" 
                                :key="`company-${company._id}`" 
                                @click="_getStores(company)" 
                                class="btn btn-company pb-2 px-1 pt-1 mr-2 mb-2 shadow-sm rounded-sm btn-navigator btn-company">
                                <div class="mb-2 mt-0 rounded p-2" style="width: 186px; height: 100px; display: inline-block" :style="`background-color: ${company.styles.primary}`">
                                    <b-img :src="company.logo_file" :height="80" style="max-width: 170px;" />
                                </div>
                                <span class="h5"><b>{{ company.brand }}</b></span><br>
                                <span class="h7">{{ company.business_name }}</span><br>
                                <b-badge class="text-white bg-secondary p-1" pill>{{ company.stores_count }} {{ $tc('fields.store', company.stores_count) }}</b-badge>
                                <div class="hover-edit">
                                    <ActionButton id="add-company"
                                            variant="transparent-primary"
                                            :hover_text="`${$t('basic.edit')} ${$tc('fields.company', 1)}`"
                                            :icon_class="`fad fa-pencil font-30`"
                                            :action="()=> { openCompaniesModal = true; companyEdit = company; action = 'companiesModal' }"
                                            class="text-primary p-1" />
                                </div>
                            </b-button>
                            <ActionButton id="add-company"
                                            variant="transparent-primary"
                                            :hover_text="`${$t('basic.add')} ${$tc('fields.company', 1)}`"
                                            :icon_class="`fad fa-plus font-36`"
                                            :action="()=> { openCompaniesModal = true;  companyEdit = {}; action = 'companiesModal' }"
                                            class="text-primary p-1" />
                        </div>
                        <!-- TIENDAS -->
                        <div v-if="Object.keys(activeCompany).length > 0 && Object.keys(activeStore).length === 0">
                            <b-button v-for="store in stores" 
                                variant="light" 
                                :key="`store-${store._id}`" 
                                @click="() => { _getAccessPoints(store); }" 
                                class="btn btn-company pb-2 px-1 pt-1 mr-2 mb-2 shadow-sm rounded-sm btn-navigator " style="width: 200px; min-height: 240px;">
                                <div class="mb-2 mt-0 rounded p-2" style="width: 186px; height: 80px; display: inline-block" :style="`background-color: ${activeCompany.styles.primary}`">
                                    <b-img :src="activeCompany.logo_file" :height="55" style="max-width: 150px;" />
                                </div>
                                
                                <!-- <i class="fad fa-store text-muted fa-2x p-1" :style="`${store.access_points_count > 0 ? '--fa-primary-color: limegreen; --fa-secondary-color: #31da07' : ''}`"></i><br>  -->
                                <span v-if="store.alias !== ''" class="h3"><b>{{ store.name }}</b></span><br>
                                {{ store.address }} <br>
                                <b-button variant="link" @click="() => { }"><i class="fad fa-map"></i> Ver Mapa</b-button><br>
                                <small class="text-danger" v-if="store.access_points_count === 0">
                                    Sin suscripciones
                                </small>
                                <small class="text-muted" v-else >
                                    <span>
                                        <b-badge class="text-white bg-primary">{{ store.access_points_count }} Access Points</b-badge>
                                    </span>
                                </small>
                            </b-button>
                            <ActionButton id="add-store"
                                            variant="transparent-primary"
                                            :hover_text="`${$t('basic.add')} ${$t('fields.store')}`"
                                            :icon_class="`fad fa-plus font-36`"
                                            :action="()=> { action = 'storesModal' }"
                                            class="text-primary p-1" />
                        </div>
                    </div>
                    <div v-if="Object.keys(activeStore).length > 0">
                        <b-button 
                            v-if="Object.keys(access_points).length > 0"
                            variant="light" 
                            :key="`all-ap-btn`" 
                            :pressed="Object.keys(activeAccessPoint).length === 0"
                            @click="getLabelsByAP()" 
                            class="btn p-2 mr-1 mb-1 shadow-sm rounded-sm btn-navigator" style="min-width: 150px; min-height: 140px;">
                            <i class="fad fa-router fa-2x p-1" 
                            :class="`${Object.keys(activeAccessPoint).length === 0 ? 'text-primary' : 'text-muted'}`"></i><br> 
                            <span class="h3"><b>{{ $t('basic.all') }}</b></span><br>
                            <span class="text-muted">{{ devices.length }} {{ $t('fields.labels')}}</span>
                        </b-button>
                            <b-button v-for="access_point in access_points" 
                            variant="light" 
                            :key="`${access_point.id}-${access_point.time}`" 
                            :pressed="activeAccessPoint.id === access_point.id"
                            @click="getLabelsByAP(access_point)" 
                            class="btn p-2 mr-1 mb-1 shadow-sm rounded-sm btn-navigator" style="min-width: 150px; min-height: 140px;">
                            <i class="fad fa-router fa-2x p-1 " :class="`${access_point.is_active !== false ? 'text-primary' : 'text-muted'}`"></i><br> 
                            <span v-if="access_point.alias !== ''" class="h3"><b>{{ access_point.alias }}</b></span><br>
                            {{ access_point.id }} <br>
                            <!-- <small class="text-muted" v-if="access_point.is_active === false">
                                Inactivo
                            </small> -->
                            <small class="text-muted" >
                                <span v-if="Object.keys(activeAccessPoint).length > 0 && Object.keys(devices).length > 0 && activeAccessPoint.id === access_point.id">
                                    <b-badge class="text-white" :class="{'bg-primary': access_point.is_active !== false}">{{ devices.filter(x => x.access_point_id === activeAccessPoint.id).length }} etiquetas</b-badge>
                                    <br>
                                </span>
                                (IP: {{ access_point.local_ip ? access_point.local_ip : 'Pendiente' }})
                            </small>
                        </b-button>
                        <ActionButton
                            id="add-accessPoint"
                            variant="transparent-primary"
                            :hover_text="`${$t('basic.add')} ${$t('fields.access_point')}`"
                            :icon_class="`fad fa-plus font-36`"
                            :action="()=> { action = 'accessPointsModal' }"
                            class="text-primary p-1" />
                    </div>
                    <b-tabs v-if="Object.keys(filteredDevices).length > 0 || Object.keys(activeAccessPoint).length > 0" card :data-time="lastTime">
                        <b-tab>
                            <template #title>
                                <i class="fad fa-mobile-alt font-20 mr-1" style="transform: rotate(90deg)"></i> {{ _.startCase($t('fields.labels')) }} <span class="badge bg-primary">{{ filteredDevices.length }}</span>
                            </template>
                            <localDatatable
                                ref="tableLabels"
                                :id="lastTime"
                                :items="filteredDevices"
                                :tableheaders="devicesFields"
                            >
                                <template #cell(id)="data">
                                    <b-button variant="link" @click="_getInformationDetail(data.item)">{{ data.value }}</b-button>
                                </template>
                                <template #cell(last_battery)="data">
                                    <i :class="`fad fa-battery-${ data.value ? Math.round((data.value / 30) * 100) < 0.5 ? 'low' : Math.round((data.value / 30) * 100) < 1 ? 'quarter' : Math.round((data.value / 30) * 100) <= 1.5 ? 'half' : Math.round((data.value / 30) * 100) <= 2.5 ? 'three-quarters' : 'full' : '' }`"
                                    :style="`--fa-primary-color: ${ data.value ? Math.round((data.value / 30) * 100) < 0.5 ? 'red' : Math.round((data.value / 30) * 100) < 1 ? 'orange' : Math.round((data.value / 30) * 100) <= 1.5 ? 'yellow' : Math.round((data.value / 30) * 100) <= 2.5 ? 'three-quarters' : 'limegreen' : '' }`"></i> 
                                    {{ data.value ? Math.round((data.value / 30) * 100)+'%' : 'N/A' }}
                                </template>
                                <template #cell(last_rf_power)="data">
                                    <i :class="`fad fa-signal-bars-${data.value ? data.value < -70 ? 'weak' : data.value < -45 ? 'good' : data.value < 0 ? 'strong' : '' : '' }`" 
                                    :style="`--fa-primary-color: ${ data.value ? data.value < -70 ? 'red' : data.value < -45 ? 'orange' : data.value < 0 ? 'limegreen' : '' : '' }`"></i> 
                                    {{ data.value ? data.value < -70 ? 'Deficiente' : data.value < -45 ? 'Buena' : data.value < 0 ? 'Excelente' : '' : '' }}
                                </template>
                                <!--<template #cell(last_temperature)="data">
                                    {{ data.value && data.value !== 0 ? `${data.value}º` : '' }}
                                </template>
                                -->
                                <template #cell(last_time)="data">
                                    <span :data-key="reloadKey">
                                        {{ data.value && getTimeFormatted(data.value) }}
                                    </span>
                                </template>
                                <template #cell(template)="data">
                                    <b-button variant="link" @click="selectTemplate(data.item)">{{ data.value }}</b-button>
                                    <LabelCanvasThumbnail 
                                        v-if="data.item.item_id && items.find(x => x.ean == data.item.item_id)" 
                                        class="label-thumbnail"
                                        :selectedTag="data.item" :itemInfo="items.find(x => x.ean == data.item.item_id)" 
                                    />
                                    </LabelCanvasThumbnail>
                                </template>
                                <template #cell(item_id)="data">
                                    <span :class="{ 'text-muted' : !data.value }">{{ data.value || '&lt;Sin asignar&gt;' }}</span>
                                    <ActionButton
                                    :id="`add-item-${data.item.id}`"
                                    variant="transparent-primary"
                                    :hover_text="data.value ? $t('basic.edit') : $t('basic.add')"
                                    :icon_class="`fad ${ data.value ? 'fa-pen' : 'fa-plus' } font-24`"
                                    :action="()=> { selectedTag = data.item; action = 'itemsModal' }"
                                    class="text-primary p-1"
                                    />
                                </template>
                                <template #cell(actions)="data">
                                    <input type="checkbox" 
                                        v-model="selectedTags"
                                        :value="{id: data.item.id, ap: data.item.access_point_id}" 
                                         :id="'selectTag'+data.item.id" />
                                </template>
                            </localDatatable>

                            <div class="row" v-if="selectedTags.length > 0">
                                <!--SE OCULTA TEMPORALMENTE:-->
                                <div class="col" v-if="1===2">
                                    <div class="input-group mb-3">
                                        <label class="input-group-text">LEDs:</label>
                                        <b-dropdown variant="link">
                                            <template #button-content >
                                                <span :style="getColorRGB">●</span> {{ getColorName }}
                                            </template>
                                            <b-dropdown-item @click="setColor('R')"><span :style="getColorRGB('R')">●</span> Red</b-dropdown-item>
                                            <b-dropdown-item @click="setColor('G')"><span :style="getColorRGB('G')">●</span> Green</b-dropdown-item>
                                            <b-dropdown-item @click="setColor('B')"><span :style="getColorRGB('B')">●</span> Blue</b-dropdown-item>
                                            <b-dropdown-item @click="setColor('R,G')"><span :style="getColorRGB('R,G')">●</span> Yellow</b-dropdown-item>
                                            <b-dropdown-item @click="setColor('R,B')"><span :style="getColorRGB('R,B')">●</span> Magenta </b-dropdown-item>
                                            <b-dropdown-item @click="setColor('G,B')"><span :style="getColorRGB('G,B')">●</span> Cyan</b-dropdown-item>
                                            <b-dropdown-item @click="setColor('R,G,B')"><span :style="getColorRGB('R,G,B')">○</span> White</b-dropdown-item>
                                        </b-dropdown>
                                        <b-dropdown variant="link">
                                            <template #button-content >
                                                x{{ LEDTimes }}
                                            </template>
                                            <b-dropdown-item @click="() => LEDTimes = 5">5</b-dropdown-item>
                                            <b-dropdown-item @click="() => LEDTimes = 10">10</b-dropdown-item>
                                            <b-dropdown-item @click="() => LEDTimes = 30">30</b-dropdown-item>
                                            <b-dropdown-item @click="() => LEDTimes = 60">60</b-dropdown-item>
                                        </b-dropdown>
                                        <button class="btn btn-sm btn-primary" :disabled="LEDTimes === 0" @click="_flashingLED()">
                                            Enviar
                                        </button>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <button class="btn btn-sm btn-primary" @click="_taskTemplate()">
                                            <i class="fad fa-refresh"></i> {{ $t('basic.refresh') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-2" >
                                <ActionButton id="add-label"
                                    variant="transparent-primary"
                                    :hover_text="`${$t('basic.add')} ${$t('fields.label')}`"
                                    :icon_class="`fad fa-plus font-24`"
                                    :action="()=> { action = 'labelsModal' }"
                                    class="text-primary p-1"
                                    :disabled="Object.keys(activeAccessPoint).length === 0"
                                    />
                                    <b-alert :show="Object.keys(activeAccessPoint).length === 0" variant="warning" class="d-inline p-1">
                                        Debes seleccionar un AP para crear una etiqueta
                                    </b-alert>
                            </div>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <i class="fad fa-inventory font-20 mr-1"></i> {{ $t('fields.items')}} <span class="badge bg-primary">{{ items.length }}</span>
                        </template>

                        <div class="d-inline">
                            <ActionButton id="add-item"
                            variant="transparent-primary"
                            :hover_text="`${$t('basic.add')} ${$t('fields.item')}`"
                            :icon_class="`fad fa-plus font-24`"
                            :action="()=> { action = 'itemsModalCreate' }"
                            class="text-primary p-1" />
                        </div>
                        <div class="d-inline">
                            <ActionButton id="add-massive-item"
                                variant="transparent-primary"
                                :hover_text="`${$t('basic.add')} ${$t('fields.item')} ${$t('basic.by')}  ${$t('basic.file')}`"
                                :icon_class="`fad fa-file-import font-24`"
                                :action="()=> { action = 'itemsMassiveModalCreate' }"
                                class="text-primary p-1 ml-1" />
                        </div>

                        <localDatatable
                            ref="tableLabels"
                            :id="lastTime"
                            :items="items"
                            :tableheaders="itemsFields"
                        >
                            <template #cell(labels)="data">
                                <span class="badge" :class="{ 'bg-secondary' : data.value.length === 0, 'bg-info' : data.value.length > 0}">{{ data.value.length }}</span>
                            </template>
                            <template #cell(actions)="data">
                                <ActionButton
                                    :id="`edit-item-${data.item._id}`"
                                    variant="transparent-primary"
                                    :hover_text="$t('basic.edit')"
                                    :icon_class="`fad fa-pen font-24`"
                                    :action="()=> { selectedItem = {...data.item}; action = 'itemsModalEdit' }"
                                    class="text-primary p-1"
                                />
                            </template>
                        </localDatatable>
                    </b-tab>
                    <b-tab>
                            <template #title>
                                <i class="fad fa-users font-20 mr-1"></i> {{ $t('pages.Users') }} <span class="badge bg-info">{{ $t('basic.coming_soon') }}</span>
                            </template>
                            <b-card>
                                <b>Nota: </b><br>
                                Módulo para gestionar los usuarios asignados a dicha tienda.
                            </b-card>
                    </b-tab>
                    <b-tab>
                            <template #title>
                                <i class="fad fa-clock font-20 mr-1"></i> Programaciones <span class="badge bg-info">{{ $t('basic.coming_soon') }}</span>
                            </template>
                            <b-card>
                                <b>Nota: </b><br>
                                <p>Módulo para subir programaciones de cambios de precios/datos. Visualización de cambios, históricos. Cambios masivos por planos TXT/CSV.</p>
                            </b-card>
                    </b-tab>
                    <b-tab>
                            <template #title>
                                <i class="fad fa-link font-20 mr-1"></i> {{ $t('basic.pairing') }} <span class="badge bg-info">{{ $t('basic.coming_soon') }}</span>
                            </template>
                            <b-card>
                                <b>Nota: </b><br>
                                <p>Módulo para emparejar etiqueta con producto mediante módulo de escáner de códigos de barras.</p>
                                <b-img src="https://www.zebra.com/content/dam/zebra_dam/global/zcom-web-production/web-production-photography/web002/retail-photography-website-blog-foodstuffs-grocery-success-story-1280x720.jpg.imgo.jpg" width="500" responsive />
                            </b-card>
                    </b-tab>
                    <b-tab>
                            <template #title>
                                <i class="fad fa-map-marker-alt font-20 mr-1"></i> {{ $t('basic.map') }} <span class="badge bg-info">{{ $t('basic.coming_soon') }}</span>
                            </template>
                            <b-card>
                                <b>Nota: </b><br>
                                <p>Módulo para editar/visualizar mapa físico del lugar y asignar ubicación a las antenas y etiquetas.</p>
                                <b-img src="https://i.pinimg.com/originals/78/a1/65/78a165f3db1121f23fe4524f40da2608.png" width="500" responsive />
                            </b-card>
                    </b-tab>
                </b-tabs>
                <!--// FOOTER: -->
                <span v-if="Object.keys(companies).length >= 0 && Object.keys(activeCompany).length === 0" class="text-muted">
                    {{ companies.length }} {{ $tc('fields.company', companies.length) }}
                </span>
                <span v-if="Object.keys(stores).length >= 0 && Object.keys(activeStore).length === 0 && Object.keys(activeCompany).length > 0" class="text-muted">
                    {{ stores.length }} {{ $tc('fields.store', stores.length) }}
                </span>
            </b-card>
        </b-overlay>
    </Layout>
</template>


<style lang="scss">
.label-thumbnail {
    pointer-events: none;
}
.btn-company {
    width: 200px; 
    min-height: 230px;   
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    img {
        margin-bottom: 0.75rem !important;
        border-radius: .2rem !important;
        display: inline-block;
        text-align: center;
        filter: drop-shadow(1px 1px 1px rgba(0,0,0,0.2));
        transform: scale(1);
        transition: 0.3s ease-in-out;
    }
    &:hover img {
        filter: drop-shadow(2px 2px 2px rgba(0,0,0,0.5));
        transform: scale(1.1);
    }
}
.btn-navigator {
    position: relative;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 8px;
    box-shadow: 0 4px 5px -2px rgba(58,53,65,.08),0 2px 8px 1px rgba(58,53,65,.12),0 2px 12px 1px rgba(58,53,65,.04);
    .hover-edit {
        position: absolute;
        display: none;
        bottom: 2px;
        right: 2px;
        width: 34px;
        height: 34px;
        align-items: end;
        justify-content: end;
    }
    &:hover .hover-edit {
        display: flex;
    }
}
</style>